import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { SsqImages } from '../../../images/SsqImages';
import downarrow from '../../../mainpage/knowledgebase/img/down-arrow.svg';
import svcs from '../../../services';
import { parseSanitize } from '../../../util/commonUtils';
import { useNavigate } from "react-router-dom";
import { langutil } from '../../../language/langutil';
import { useLoginInfo } from '../../../hooks/useLoginInfo';
import { useParams } from "react-router-dom";
import { PolicyDetailRes, PolicyVersionRes } from 'communitypage/privacypolicy/types/policy.types';
import { usePolicyApi } from 'communitypage/privacypolicy/hooks/useApiPrivacyPolicyPage';
import { EditorStyle } from 'style/SsqEditorStyle';

const PrivacyPolicyPage: React.FC = () => {
  const CDN_BASE_URL = `${import.meta.env.VITE_APP_BLOB_STORAGE_CDN_URL}`;

  const navigate = useNavigate();
  const { country, lang } = langutil.splitLangCode(svcs.svcLang.lang());
  const { documentId } = useParams();

  const loginInfo = useLoginInfo();
  const isSystemAdmin = loginInfo?.allowAdminManage;
  
  const [isBtnOpen, setIsBtnOpen] = useState(false);
  const [isViewMoreOpen, setisViewMoreOpen] = useState(false);

  const [versionList, setVersionList] = useState<PolicyVersionRes[]>([]);
  const [selectedVersion, setSelectedVersion] = useState<PolicyVersionRes | null>(null);
  const [selectedVersionDetail, setSelectedVersionDetail] = useState<PolicyDetailRes | null>(null);

  const { getGuestPolicyDetail, getAdminPolicyDetail, getAdminPolicyList, getGuestPolicyList, deletePolicy } = usePolicyApi();

  const trans = (key: string) => {
    svcs.svcLang.setNamespace("I18N_NAMESPACE_ADMIN_PAGE");
    return svcs.svcLang.getTranslationByKey(key) || "";
  };

  const handleToggleVersion = async () => {
    if (versionList.length <= 1) return;

    const next = !isBtnOpen;
    setIsBtnOpen(next);

    if (next) {
      await requestPolicyList();
    }

    if (isViewMoreOpen) {
      setisViewMoreOpen(false);
    }
  };

async function requestCurrentVersionDetail() {
  try {
    const param = { isTemp: false, exposeSiteLanguage: 'en-US' };

    const data = isSystemAdmin
      ? await getAdminPolicyList(param)
      : await getGuestPolicyList(param);

    setVersionList(data);
    setSelectedVersion(data[0]);

    const CurrentVersion = isSystemAdmin
      ? await getAdminPolicyDetail(data[0].id)
      : await getGuestPolicyDetail(data[0].id);

    setSelectedVersionDetail(CurrentVersion);

  } catch (e) {
    console.error('최신 정책 조회 실패', e);
  }
}

  const requestPolicyDetail = async (id: number) => {
    try {
      const data = isSystemAdmin
        ? await getAdminPolicyDetail(id)
        : await getGuestPolicyDetail(id);

      setSelectedVersionDetail(data);
    } catch (e) {
      console.error('정책 상세 조회 실패', e);
    }
  };

  const requestPolicyDetailById = async (id: number) => {
    try {
      const data = isSystemAdmin
        ? await getAdminPolicyDetail(id)
        : await getGuestPolicyDetail(id);

      setSelectedVersionDetail(data);

      setSelectedVersion({
        id: data.id,
        version: data.version,
        expose: data.expose,
      } as any);

    } catch (e) {
      console.error('정책 상세 조회 실패', e);
    }
  };

  async function requestPolicyList() {
    try {
      const param = { isTemp: false, exposeSiteLanguage: 'en-US', };

      console.log("isSystemAdmin", isSystemAdmin);

      const data = isSystemAdmin
        ? await getAdminPolicyList(param)
        : await getGuestPolicyList(param);

      setVersionList(data);

    } catch (e) {
      console.error('정책 리스트 조회 실패', e);
    }
  }

  async function requestPolicyDelete() {
    try {
      await deletePolicy(selectedVersionDetail?.id ?? 0);
      navigate(`/${country}/${lang}/privacypolicy`);
    } catch (e) {
      console.error('정책 리스트 삭제 실패', e);
    }
  }

  useEffect(() => {
    if (!loginInfo) return;

    if (documentId && Number(documentId) > 0) {
      requestPolicyDetailById(Number(documentId));
    } else {
      requestCurrentVersionDetail();
    }
  }, [loginInfo, documentId]);

  const renderHead = () => {
    return (
      <>
        <div className={"date_and_version"}>
          <div className="date_and_version_item">
            <span className="date_name">Revision date</span>
            <span className="date_value"> {selectedVersionDetail?.revisionTime?.split('T')[0]} </span>
          </div>

          <div className="date_and_version_item">
            <span className="date_name"> Effective Date</span>
            <span className="date_value"> {selectedVersionDetail?.effectiveTime?.split('T')[0]} </span>
          </div>

          <VersionWrapper>
            <div className="version"> {trans('I18N_VERSION')} </div>
            <Btn onClick={handleToggleVersion}>
              {selectedVersion?.version ?? '-'}

              {versionList.length > 1 && <img src={downarrow} />}
            </Btn>

            {!selectedVersion?.expose && (
              <span className="badge_private outside">{trans("I18N_FILTER_NOT_EXPOSE")}</span>
            )}

            {isSystemAdmin && (
            <div className="btn-list-modify"
              onClick={() => {
                setisViewMoreOpen(!isViewMoreOpen);
                if (isBtnOpen) {
                  setIsBtnOpen(false); }
              }}>
              {isViewMoreOpen && <div className="view_more_dropdown">

                <button className="view_more_dropdown_item modify" onClick={() => {
                  navigate(`/${country}/${lang}/privacypolicy/new/${selectedVersionDetail.id}`);
                  setisViewMoreOpen(!isViewMoreOpen);
                }}>{trans('I18N_MODIFIED')}
                </button>
                <button className="view_more_dropdown_item delete" onClick={() => {
                  const confirmed = window.confirm('이 글을 삭제하시겠습니까?');

                  if (confirmed) {
                    requestPolicyDelete();
                  }
                }}>{trans('I18N_BUTTON_DELETE')}
                </button>
                <button className="view_more_dropdown_item add" onClick={() => {
                  navigate(`/${country}/${lang}/privacypolicy/new/0`);
                }}>{trans('I18N_ADD_BTN')}
                </button>
              </div>}
            </div>
            )}

            {isBtnOpen && (
              <div className="version_dropdown">
                {versionList.map((v, idx) => (
                  <div
                    key={v.id}
                    className="version_dropdown_item"
                    onClick={async () => {
                      setSelectedVersion(v);
                      setIsBtnOpen(false);

                      await requestPolicyDetail(v.id);
                    }}>
                    <span className="version_text">{v.version}</span>
                    {!v.expose && (
                      <span className="badge_private">{trans("I18N_FILTER_NOT_EXPOSE")}</span>
                    )}
                  </div>))}
              </div>
            )}
          </VersionWrapper>
        </div>
      </>
    );
  };

  const renderFiles = () => {
    const files = selectedVersionDetail?.files ?? [];
    if (files.length === 0) return null;

    return (
      <div className="download_doc">
        {files.map((file) => (
          <a
            key={file.id}
            className="download_doc_item"
            href={`${CDN_BASE_URL}/${file.fileKey}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DownloadDocItem>
              <span className="file_name">
                {file.fileName}
              </span>
              <img
                alt="download_icon"
                src={SsqImages.common.icon.downloadImg()}
              />
              <span className="file_size">
                {formatFileSize(file.fileSize)}
              </span>
            </DownloadDocItem>
          </a>
        ))}
      </div>
    );
  };

  const formatFileSize = (size: number) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  };


  const renderContent = () => {
    return (
      <>
        <Contents>
          <DocContent>
          <div className={"accordion-version"}>
            <div
              className={"version-desc SsqEditor ck-content"}>{parseSanitize(selectedVersionDetail?.description ?? "")}</div>
          </div>
          </DocContent>
        </Contents>
      </>
    );
  };

  return (
    <>
      <Container>
        <div className={"privacy_policy_title"}> Privacy Policy</div>
        {renderHead()}
        {renderFiles()}
        {renderContent()}
      </Container>
    </>
  );
};

export default PrivacyPolicyPage;

const Container = styled.div`
  max-width: 120rem;
  margin: 0 auto;
  height: fit-content;

  @media (max-width: 1200px) {
    padding: 0 18px;
  }

  .privacy_policy_title {
    height: 80px;
    margin-top: 50px;
    font-size: 48px;
    font-weight: bold;

    @media (max-width: 768px) {
      font-size: 40px;
    }
  }

  .date_and_version {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
    padding-right: 33px;
    padding-bottom: 40px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.8rem;
    }
  }

  .date_name {
    padding-right: 10px;
    align-items: center;
  }

  .date_value {
    padding-right: 35px;
    font-weight: lighter;
    color: rgb(0, 0, 0, 0.6);
  }

  .download_doc {
    display: flex;
    flex-direction: column;
    margin-bottom: 4rem;
  }

  .download_doc_item {
    display: flex;
    max-width: 60rem;
    align-items: center;
    font-size: 16px;
    font-weight: normal;
    height: 40px;
    color: #3F7DD9;

    @media (max-width: 768px) {
      font-size: 14px;
      max-width: 100%;
      height: auto;
      padding: 0.4rem 0;
    }
  }
`;

export const DownloadDocItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  min-width: 0;

  .file_name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;
  }

  .file_size {
    flex-shrink: 0;
    font-size: 12px;
    color: gray;
  }

  img {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }
`;

const Contents = styled.div`
    padding-bottom: 88px;
`;

const DocContent = styled.div`
  ${EditorStyle};
  overflow-x: auto;

  /* 테이블 감싸는 figure에서 가로 스크롤 허용 */
  .ck-content .table,
  .SsqEditor figure:has(table) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    max-width: 100%;
  }

  /* 테이블 최소 너비 확보 → 좁으면 스크롤 발생 */
  .ck-content table,
  .SsqEditor table {
    display: table !important;
    min-width: 600px;
  }

  /* 셀 내용 줄바꿈 방지 */
  .ck-content table td,
  .ck-content table th,
  .SsqEditor table td,
  .SsqEditor table th {
    word-break: keep-all;
    white-space: nowrap;
    font-size: 13px;
  }

  /* 모바일 테이블 폰트 축소 */
  @media (max-width: 768px) {
    .ck-content table td,
    .ck-content table th,
    .SsqEditor table td,
    .SsqEditor table th {
      font-size: 11px;
      padding: 5px 6px;
    }
  }

  @media (max-width: 480px) {
    .ck-content table td,
    .ck-content table th,
    .SsqEditor table td,
    .SsqEditor table th {
      font-size: 10px;
      padding: 4px 5px;
    }
  }
`;




export const VersionWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  
  .version{
    padding-right: 1rem;
    font-size: 14px;
  }

  .version_dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    border: 1px solid #ddd;
    padding: 0.5rem 0;
    border-radius: 5px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 20px;
    font-size: 1.2rem;
    width: 85%;
    z-index: 10;
  }

  .version_dropdown_item {
    padding: 10px 20px;
    cursor: pointer;

    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .version_dropdown_item:hover {
    background-color: #f5f5f5;
  }

  .badge_private {
    font-size: 11px;
    background-color: #6b7280; /* 살짝 회색 */
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
  }

  .badge_private.outside {
    margin-left: 8px;
    font-size: 10px;
  }

  .btn-list-modify {
    width: 2.4rem;
    height: 2.4rem;
    background: url("${SsqImages.community.icon.communitySpotMore()}") no-repeat center;
    cursor: pointer;
  }

  .view_more_dropdown {
    position: absolute;
    top: 100%;
    left: 90%;
    border: 1px solid #ddd;
    padding: 1rem 1rem;
    border-radius: 5px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 20px;
    font-size: 1.2rem;
    z-index: 10;
  }
  .view_more_dropdown_item {
    padding: 10px 12px;
    cursor: pointer;
  }
  .view_more_dropdown_item:hover  {
    background-color: #f5f5f5;
  }
`;

const Btn = styled.div`
  border: 2px solid #e5e5e5;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 20px;
  color: #191a1c;
  border-radius: 5rem;
  font-size: 1.2rem;
  padding: 0.6rem 2rem;
  cursor: pointer;

  & img {
    margin-left: 0.6rem;
  }
`;
